import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const TransportistaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)

  const [transportistas, setTransportistas] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TRANSPORTISTA)
      .then(({ data }) => setTransportistas(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TRANSPORTISTA).then(({ data }) => {
      setTransportistas(data)
    })
    setMostrarModalCrud(false)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='TRANSPORTISTA' htmlFor='select-_idTransportista' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.InputGroup>
            <Field name='_idTransportista'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='select-_idTransportista'
                >
                  <option value=''>Seleccionar</option>
                  {transportistas.map((val, key) => (
                    <option key={key} value={val._id}>
                      {val.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.TRANSPORTISTA}
        />
      )}
    </>
  )
}

export default React.memo(TransportistaFormGroup)
